import { QuoteSetupItems } from '@/models/cart'
import { getBoughtServicesTotal } from './timeSchedules'

export const getGlobalBoughtQuantity = (quotableProducts: QuoteSetupItems) => {
  return Object.values(quotableProducts.boughtServices).reduce(
    (carry, boughtService) => carry + getBoughtServicesTotal(boughtService),
    0
  )
}
